import { AuthenticationEntity } from "@modules/auth/entities/auth.entity";
import { API_HEADER, API_URL } from "@modules/shared/enums/common-enum";
import { fetchWithAuth } from "@modules/shared/helpers/fetch-with-auth.helper";

function getHeaders(): HeadersInit {
  return {
    ...API_HEADER,
  };
}

export default async function FcmTokenService(
  data: { token: string },
  auth: AuthenticationEntity | null,
  setAuth: (auth: AuthenticationEntity | null) => void,
  logout: () => void
) {
  try {
    const response = await fetchWithAuth(
      `${API_URL.UPSERT_FCM_TOKEN}`,
      {
        method: "POST",
        headers: {
          ...getHeaders(),
          "x-platform": "web",
        },
        body: JSON.stringify(data),
      },
      auth,
      setAuth,
      logout
    );

    return response;
  } catch (error) {
    console.error(`Failed to save FCM token !`, error);
    throw error;
  }
}
